import { EDITOR } from 'constants/actionTypes';
import request from 'utils/request_ajax';
import { autosaveInProgress, autosaveSuccess, autosaveFail } from './index';

// @TODO write documentation for this file

export const lessonUpdate = changes => ({
  type: EDITOR.LESSON.UPDATE,
  ...changes,
});

// @TODO id here is the section’s id, but should be the lesson’s
export const requestUpdate = (id, changes) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const { lesson_title_update, lessonId } = getState().editor;

    // Update Backbone collection
    if (changes.title) {
      lly.lessons.addOrUpdate({ id: lessonId, title: changes.title });
    }
    dispatch(autosaveInProgress());
    request
      .put(lesson_title_update, { lesson: changes })
      .done(data => {
        dispatch(autosaveSuccess());
        dispatch(lessonUpdate(changes));
      })
      .fail(error => {
        dispatch(autosaveFail());
        reject(error);
      });
  });
